<template>
    <div>
        <button class="a-button" v-if="!noDefaultButton" @click="toggleThisModal">{{buttonName}}</button>
        <div class="o-modal" :class="[name, { 'o-modal--open': isThisModalOpen }] ">
            <div class="o-modal__container" :class="{'o-modal__container--wide': wide}">
                <div class="o-modal__close-button" @click="toggleThisModal"></div>
                <div class="o-modal__content">
                    <slot></slot>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapGetters, mapActions} from 'vuex';

    export default {
        name: 'modal',
        props: {
            name: {
                type: String,
                default: '',
                required: true
            },
            noDefaultButton: {
                default: false
            },
            buttonName: {
                type: String,
                default: ''
            },
            wide: {
                type: Boolean,
                default: false
            }
        },
        computed: {
            ...mapGetters('modal', ['modals']),
            ...mapGetters('documents', ['getEditingDocument', 'getExitAllowed', 'showingExitNotification']),
            isThisModalOpen() {
                return this.modals[this.name];
            },
        },
        created() {
            this.register(this.name);
        },
        mounted() {
            window.addEventListener('keyup', (event) => {
                if (event.keyCode === 27) {
                    this.closeModal(this.name);
                }
            });
        },
        destroyed() {
            this.unregister(this.name);
        },
        methods: {
            ...mapActions('modal', ['toggle', 'register', 'unregister', 'resetModal', 'closeModal']),
            ...mapActions('documents', ['quitEditingDocument', 'exitAttempted', 'exitClosed']),
            toggleThisModal() {
                this.quitEditingDocument();
                this.toggle(this.name);
                this.resetModal();
            },
        }
    }
</script>



// WEBPACK FOOTER //
// Modal.vue?02f7d05d